import React from 'react';
import {useParams} from "wouter";
import {swrFetcher} from "../../utils/api.ts";
import Avatar from "../../components/Avatar.tsx";
import useSWRImmutable from "swr/immutable";
import Spinner from "@/components/spinner.tsx";

function AccountDetails() {
    const {id} = useParams<{id:string}>()
    const {data, isLoading, mutate} = useSWRImmutable(`/accounts/${id}`, swrFetcher)
    if(isLoading){
        return <div className="text-center"><Spinner /></div>
    }
    return (
        <div className={"d-flex"}>
            <div className="d-flex gap-4">
                <Avatar alt={data?.username} src={data?.picture?.url} size={180} />
                <div className="mt-2 ms-4">
                    <h3>{data?.name}</h3>
                    <p className="text-muted">{data?.username}</p>
                    <p>{data?.bio}</p>
                    <p className="d-flex gap-4">
                        {
                            data.platform === "instagram" ? <>
                              <span>{data?.media_count} posts</span>
                               <span>&middot;</span>
                              <span>{data?.followers_count} followers</span>
                              <span>&middot;</span>
                              <span>{data?.following_count} following</span>
                              </> : null
                        }
                        {
                            data.platform === "twitter" ? <>
                                <span>{data?.post_count} tweets</span>
                                <span>&middot;</span>
                                <span>{data?.followers_count} followers</span>
                                <span>&middot;</span>
                                <span>{data?.following_count} following</span>
                                </> : null
                        }
                        {
                            data.platform === "facebook" ? <>
                                <span>{data?.followers_count} followers</span>
                            </> : null
                        }


                    </p>
                    <div>{data?.biography}</div>

                </div>
            </div>
        </div>
    );
}

export default AccountDetails;
